import { Injectable, inject } from '@angular/core';
import { DwActiveLookupRequestDto, DwLookupRequestDto } from '@digiwall/goliath-core/proxy';
import { EquipmentService } from '@digiwall/goliath-products/proxy';
import { WorkerService } from '@digiwall/goliath-contacts/proxy';
import { ProductionFolderFilterOptionsService } from '../production-folder/production-folder-filter-options.service';

/**
 * Option sources for the ProductionStep planning filters. Reuses every parent-document option of the
 * base {@link ProductionFolderFilterOptionsService} (day-books, customer, manufacturer) and adds the
 * step-line specific lazy lookups: Equipment and Worker, both wired through `ng-select` + the
 * `dwApiSelect` directive for typeahead over large lists. Shared by the config filter panel (preset
 * selection) and the board filter (interactive controls).
 */
@Injectable({ providedIn: 'root' })
export class ProductionStepFilterOptionsService extends ProductionFolderFilterOptionsService {
  private readonly equipmentService = inject(EquipmentService);
  private readonly workerService = inject(WorkerService);

  /** Lazy equipment lookup for `[dwApiSelect]`. */
  readonly equipmentSelect = (dto: DwLookupRequestDto<string>) => {
    dto.sorting = [{ property: 'name' }];
    dto.queryProperties = ['code', 'name'];
    return this.equipmentService.getLookupList(dto);
  };

  /** Lazy worker lookup for `[dwApiSelect]`. */
  readonly workerSelect = (dto: DwActiveLookupRequestDto<string>) => {
    dto.onlyActive = true;
    dto.sorting = [{ property: 'code' }];
    dto.queryProperties = ['code', 'firstName', 'lastName'];
    return this.workerService.getLookupList(dto);
  };
}
